import React from "react";
import Header from "../components/Header";
import { useTranslation } from 'react-i18next';

export default function PrivatTerms(){
    const { t } = useTranslation();

    return(
        <div className="termsWr"> 
            <Header type="black" pageTitle={t(`Message.home_tail_privacy_policy`)}/>
            <div className="termsCont">
                <div className="termsArea">
                    <p>살리코리아(이하 “회사”)는 개인정보 보호 관련 법령에 따라 고객의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립〮공개합니다.</p>
                    <h3 className="mt40">제1장   개인정보의 수집 및 이용목적</h3>
                    <p>회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 법률에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>
                    <div className="tableXscroll">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>구분</th>
                                    <th>목적</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>회원가입</td>
                                    <td>
                                        <p>회원 가입의사 확인, 이용자 식별 및 본인여부, 회원자격 유지〮관리, 계약 이행 및 약관변경 고지를 위한 연락, 본인의사 확인 및 민원처리, 부정이용 방지, 비인가 사용방지, 서비스 제공 및 계약의 이행, 서비스 이용 및 상담, 문의, 후기를 위한 원활한 의사소통 경로 확보, 맞춤형 서비스 제공</p>
                                        <p>서비스 방문 및 이용기록 분석, 부정이용 방지를 위한 기록 관리, 앱 서비스 이용자 식별, 맞춤형 서비스 제공</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>재화 또는 서비스 이용 및 제공</td>
                                    <td>물품배송, 상품 및 주문, 서비스 만족도 조사, 계약서〮청구서 발송, 콘텐츠 제공, 맞춤형 서비스 제공, 마케팅 활동, 본인인증, 연령인증, 요금결제〮정산, 환불처리</td>
                                </tr>
                                <tr>
                                    <td>마케팅 및 광고</td>
                                    <td>
                                        <p>웹 페이지 접속빈도 파악 또는 회원의 서비스 이용에 대한 통계</p>
                                        <p>이벤트 등 광고성 정보 전달</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <h3 className="mt40">제2장 개인정보 수집 항목 및 방법</h3>
                    <p>회사는 다음의 개인정보 항목을 수집하여 처리하고 있습니다.</p>
                    <div className="tableXscroll">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>목적</th>
                                    <th>구분</th>
                                    <th>개인정보 항목 (필수)</th>
                                    <th>개인정보 항목 (선택)</th>
                                    <th>수집방법</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td rowspan="2">회원가입</td>
                                    <td>회원가입</td>
                                    <td>이름, 아이디, 비밀번호, 휴대폰번호, 이메일, 주소</td>
                                    <td>-</td>
                                    <td rowspan="2">홈페이지, 모바일앱</td>
                                </tr>
                                <tr>
                                    <td>SNS 가입</td>
                                    <td>
                                        <p>페이스북: 페이스북 계정</p>
                                        <p>구글:</p>
                                        <p>네이버: </p>
                                        <p>틱톡: </p>
                                        <p>카카오: </p>
                                    </td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td rowspan="3">재화 또는 서비스 이용 및 제공</td>
                                    <td>상품주문</td>
                                    <td>결제정보, 수취인 이름, 수취인 휴대폰 번호, 수취인 주소, 구매상품 정보</td>
                                    <td>-</td>
                                    <td rowspan="3">홈페이지, 모바일앱, 이메일, 팩스, 고객센터를 통한 전화와 온라인 상담</td>
                                </tr>
                                <tr>
                                    <td>취소 및 환불</td>
                                    <td>예금주, 은행명, 계좌번호</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>대량주문 문의</td>
                                    <td>
                                        <p>신청자 정보 (이름, 연락처, 이메일, 살리ID)</p>
                                        <p>수령자 정보 (이름, 연락처, 배송지 주소)</p>
                                    </td>
                                    <td>-</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p className="pt10">※ 회사의 서비스 이용 과정에서 서비스 이용기록, 방문기록, 불량 이용기록, IP주소, 쿠키, MAC주소, 모바일 기기정보(앱버전, OS버전, 디바이스 ID)등의 정보가 자동으로 생성되어 수집 및 이용될 수 있습니다.</p>
                    <p>※ 진행하는 이벤트에 따라 수집항목이 상이할 수 있으므로 응모시 별도 동의를 받으며, 수집된 정보는 목적 달성 즉시 파기합니다.</p>

                    <h3 className="mt40">제3장 개인정보의 보유 및 이용기간</h3>
                    <p>① 회사는 법령에 따른 개인정보 보유〮이용 기간 또는 이용자로부터 개인정보 수집 시에 동의 받는 개인정보 보유〮이용기간 내에서 개인정보를 처리〮보유합니다.</p>
                    <p>② 각각의 개인정보 처리 및 보유기간은 다음과 같습니다.</p>
                    <p className="pl16">1. 홈페이지 회원 가입 및 관리 : 회원 탈퇴 시 즉시 파기</p>
                    <p className="pl30">(단, 부정이용 방지를 위하여 3개월 동안 보관(아이디, 휴대폰 번호) 후 파기하며, 재화 또는 서비스 제공에 해당하는 경우는 관련 법령에 의거하여 보유 기간 동안 보관 후 파기함.)</p>
                    <p className="pl30">다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료시까지</p>
                    <p className="pl40">- 관계 법령 위반에 따른 수사 조사 등이 진행중인 경우에는 해당 수사 조사 종료시까지</p>
                    <p className="pl40">- 서비스 이용에 따른 채권 채무관계 잔존시에는 해당 채권 채무관계 정산시까지</p>

                    <p className="pt10 pl16">2. 재화 또는 서비스 제공 : 재화〮서비스 공급완료 및 요금결제〮정산 완료시까지</p>
                    <p className="pl30">- 대량주문 문의 : 문의 완료일로부터 30일 보관 후 파기</p>

                    <p className="pt20">③ 다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료시까지</p>
                    <p className="pl16">1. 법령에 의한 정보 보유</p>

                    <div className="tableXscroll">
                        <table className="table">

                            <thead>
                                <tr>
                                    <th>대상</th>
                                    <th>관련 법 조항</th>
                                    <th>보유기간</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>계약 또는 청약철회 등에 관한 기록</td>
                                    <td rowspan="3">전자상거래등에서 소비자 보호에 관한 법률</td>
                                    <td>5년</td>
                                </tr>
                                <tr>
                                    <td>대금결제 및 재화 등의 공급에 관한 기록</td>
                                    <td>5년</td>
                                </tr>
                                <tr>
                                    <td>소비자의 불만 또는 분쟁처리에 관한 기록</td>
                                    <td>3년</td>
                                </tr>
                                <tr>
                                    <td>본인 확인에 대한 기록</td>
                                    <td>정보통신 이용촉진 및 정보보호 등에 관한 법률</td>
                                    <td>6개월</td>
                                </tr>
                                <tr>
                                    <td> 인터넷 로그기록 자료, 접속지 추적자료</td>
                                    <td>통신비밀보호법</td>
                                    <td>3개월</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p className="pl16">2. 회사 방침에 의한 정보 보유</p>
                    <p className="pl30">- 보유 목적 : 분쟁조정, 고객문의 대응 및 법령 준수 이력 증빙</p>
                    <p className="pl30">- 보유 항목 : 이메일, 문자, 알림톡 발송이력(이름, 아이디, 휴대폰 번호, 이메일)</p>
                    <p className="pl30">- 보유 기간 : 발송일로부터 6개월</p>



                    <h3 className="mt40">제4장 개인정보의 파기절차 및 방법</h3>
                    <p>① 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.</p>
                    <p>② 이용자로부터 동의 받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존해야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다. 별도 보존되는 개인정보는 법률에 의한 경우가 아니고서는 보존목적 이외의 다른 목적으로 이용되지 않습니다.</p>
                    <p>③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.</p>
                    <p className="pl16">파기절차</p>
                    <p className="pl30">- 회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.</p>
                    <p className="pl16 pt10">파기방법</p>
                    <p className="pl30">- 전자적 파일 형태로 저장된 개인정보는 기록을 복원이 불가능한 방법으로 영구 파기하며, 종이문서에 저장된 개인정보는 분쇄기로 분쇄하거나 소각 등을 통하여 파기합니다.</p>


                    <h3 className="mt50">제5장 개인정보의 제3자 제공</h3>
                    <p>① 회사는 이용자의 개인정보를 수집시 명시한 범위 내에서만 개인정보를 처리하며, 원칙적으로 개인정보를 제3자에게 제공하지 않습니다.</p>
                    <p>② 단, 원활한 서비스 제공을 위하여 제3자 제공에 동의하는 경우에 한해서 상품 구매시 이용자의 개인정보 (서비스 제공 및 배송, 본인확인 등을 위하여 필요한 최소한의 개인정보)를 서비스 제공 업체에게 제공합니다.</p>
                    <p className="pl16">※ 제3자 제공에 동의하지 않은 경우 상품배송이 어려울 수 있습니다.</p>
                    <div className="tableXscroll">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>제공받는 자</th>
                                    <th>제공 항목</th>
                                    <th>제공 목적</th>
                                    <th>보유 및 이용기간</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>한진택배</td>
                                    <td>이름, 연락처, 주소, 구매상품정보</td>
                                    <td>상품배송</td>
                                    <td>
                                        <p>목적 달성 후 파기</p>
                                        <p>(단, 타법령에 따라 법령에서 규정한 기간동안 보존)</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p>③ 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우 이용자의 개인정보를 제공할 수 있습니다.</p>




                    <h3 className="mt50">제6장 개인정보처리의 위탁</h3>
                    <p>① 회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
                    <div className="tableXscroll">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>위탁 받는 자</th>
                                    <th>위탁업무의 내용</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>한진택배</td>
                                    <td>문자발송 서비스, 카카오 알림톡, 결제 및 정산 서비스 , 배송서비스</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p>② 회사는 위탁계약 체결 시 위탁업무 수행목적 외 개인정보 처리금지, 기술적 관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리 감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</p>




                    <h3 className="mt50">제7장 이용자 및 법정대리인의 권리와 그 행사방법</h3>
                    <p>① 이용자는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.</p>
                    <p className="pl16">1. 개인정보 열람요구</p>
                    <p className="pl16">2. 오류 등이 있는 경우 정정 요구</p>
                    <p className="pl16">3. 삭제 요구</p>
                    <p className="pl16">4. 처리정지 요구</p>
                    <p className="pt10">② 이용자는 홈페이지의 “개인정보 수정“,”회원탈퇴“ 메뉴 및 회사에 대해 서면, 전화, 모사전송(FAX)등을 통하여 권리 행사를 할 수 있으며, 회사는 이에 대해 지체없이 조치합니다.</p>
                    <p className="pl16">1. 개인정보 수정, 회원탈퇴 경로 및 방법</p>
                    <p className="pl30">- 개인정보 수정 : 로그인 → 마이살리 → 회원정보 변경 → 비밀번호 확인 → 개인정보 수정</p>
                    <p className="pl30">- 회원탈퇴 하기 : 로그인 → 마이살리 → 회원정보 변경 → 비밀번호 확인 → 탈퇴하기</p>
                    <p className="pt10">③ 이용자가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.</p>
                    <p>④ 이용자에 따른 권리 행사는 이용자의 법정대리인이나 위임을 받은 자 등 대리인을 통해서 하실 수 있습니다. 이 경우에는 위임장을 제출하여야 합니다.</p>
                    <p>⑤ 이용자는 개인정보 보호 유관법령을 위반하여, 회사가 처리하고 있는 이용자 본인이나 타인의 개인정보 및 사생활을 침해하여서는 아니됩니다.</p>



                    <h3 className="mt50">제8장 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항</h3>
                    <p>살리는 이용자에게 개별적인 맞춤화된 서비스를 제공하기 위해 이용 정보를 저장하고 수시로 불러오는 ‘쿠키(Cookie)’를 사용합니다. 이용자가 웹사이트에 접속할 경우 웹 사이트 서버는 이용자의 디바이스에 저장되어 있는 쿠키의 내용을 읽어 이용자의 환경설정을 유지하고 맞춤화된 서비스를 제공하게 됩니다.</p>
                    <p className="pt8">1. 쿠키의 사용목적</p>
                    <p className="pl16">- 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.</p>
                    <p className="pt8">2. 쿠키 설치 운영 및 거부</p>
                    <p className="pl16">- 이용자는 쿠키 설치에 대한 선택권을 가지고 있으며, 웹 브라우저별 옵션 선택을 통해 모든 쿠키를 허용 또는 거부하거나 쿠키가 저장될 때마다 확인을 거치도록 할 수 있습니다. 쿠키 설치 허용여부를 지정하는 방법은 다음과 같습니다.</p>
                    <p className="pt8 pl30">- Microsoft Edge : 도구 메뉴 → 인터넷 옵션 → 개인정보 탭 → 개인정보처리 수준 설정</p>
                    <p className="pl30">- Chrome : 설정 메뉴 → 고급 설정 표시 선택 → 개인정보-콘텐츠 설정 → 쿠키 수준 설정</p>
                    <p className="pl30">- Firefox :  옵션 메뉴 → 개인정보 → 방문기록-사용자 정의 설정 → 쿠키 수준 설정</p>
                    <p className="pl30">- Safari : 환경설정 메뉴 → 개인정보 탭 → 쿠키 및 웹사이트 데이터 수준 설정</p>
                    <p className="pt8">3. 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.</p>



                    <h3 className="mt50">제9장 모바일 앱 사용시 광고 식별자(ADID/IDFA) 수집</h3>
                    <p>회사는 이용자의 ADID/IDFA를 수집 및 이용할 수 있습니다. ADID/IDFA란 모바일 이용자의 광고 식별 값으로, 사용자의 맞춤 서비스 제공이나 더 나인 환경의 광고를 제공하기 위하여 활용됩니다.</p>
                    <p className="pt8">거부방법</p>
                    <p className="pl16">- Android :  설정 → 구글(구글설정) → 광고 → 광고 맞춤설정 선택 해제</p>
                    <p className="pl16">- iOS : 설정 → 개인정보 보호 → 광고 → 광고 추적 제한</p>



                    <h3 className="mt50">제10장 개인정보의 안전성 확보 조치</h3>
                    <p>회사는 개인정보의 안전성 확보를 위해 다음과 같이 조치를 취하고 있습니다.</p>
                    <p className="pl16">1. 관리적 조치 :  내부관리계획 수립 시행, 정기적 직원 교육 등</p>
                    <p className="pl16">2. 기술적 조치 : 개인정보처리시시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안 프로그램 설치 등</p>
                    <p className="pl16">3. 물리적 조치 : 전산실, 자료보관실 등의 접근 통제</p>



                    <h3 className="mt50">제11장 개인정보 보호책임자</h3>
                    <p>① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해규제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
                    <div className="tableXscroll">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>개인정보 보호책임자</th>
                                    <th>개인정보 민원처리 담당부서</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <p>이름: 김재웅</p>
                                        <p>직책: 정보보호 담당</p>
                                        <p>전화번호: 044-</p>
                                        <p>이메일: privacy@shimsoft.com</p>
                                    </td>
                                    <td>
                                        <p>소속: 고객서비스팀</p>
                                        <p>이메일: help@shimsoft.com</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p>② 이용자는 회사의 서비스를 이용하면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당자에게 문의하실 수 있습니다. 회사은 이용자의 문의에 대해 지체없이 답변 및 처리를 지원합니다.</p>





                    <h3 className="mt50">제12장 이용자의 권익침해에 대한 구제방법</h3>
                    <p>① 이용자는 아래의 기관에게 개인정보 침해에 대한 피해구제, 상담 등을 문의하실 수 있습니다.</p>
                    <p className="pl16">※ 아래의 기관은 회사와는 별개의 기관으로서, 회사의 자체적인 개인정보 불만처리, 피해구제 결과에 만족하지 못하시거나 보다 자세한 도움이 필요하시면 문의하여 주시기 바랍니다.</p>
                    <p>② 기타 개인정보침해에 대한 신고나 상담이 필요한 경우에는 아래 기관에 문의하시기 바랍니다.</p>
                    <div className="tableXscroll">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>문의처</th>
                                    <th>연락처</th>
                                    <th>홈페이지</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>개인정보침해신고센터</td>
                                    <td>(국번없이) 118</td>
                                    <td>privacy.kisa.or.kr</td>
                                </tr>
                                <tr>
                                    <td>개인정보분쟁조정위원회</td>
                                    <td>1833-6972</td>
                                    <td>www.kopico.go.kr</td>
                                </tr>
                                <tr>
                                    <td>대검찰청 사이버수사과</td>
                                    <td>(국번없이) 1301</td>
                                    <td>www.spo.go.kr</td>
                                </tr>
                                <tr>
                                    <td>경찰청 사이버범죄 신고시스템(ECRM)</td>
                                    <td>(국번없이) 182</td>
                                    <td>ecrm.cyber.go.kr/minwon/main</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>





                    <h3 className="mt50">제13장 개인정보처리방침의 개정과 그 공지</h3>
                    <p>본 개인정보 처리방침을 개정할 경우에는 홈페이지를 통해 변경내용을 공지하도록 하겠습니다.</p>
                    <p className="pt8 pl8">- 공고일자 : 2024년 0월 00일</p>
                    <p className="pl8">- 시행일자 : 2024년 0월 00일</p>
                </div>
            </div>
        </div>
    );
};